import React,{ useState,useEffect } from "react";
import { MdDelete } from "react-icons/md";
import { toast } from "react-toastify";
import { NEW_ARTICLES } from "../../../../utils/constants";
import FoodExpense from "../halper/foodExpanse";

const AllowanceOutsideSweden = ({
  register,
  errors,
  editData,
  isFileUploaded,
  setValue,
  setOpenModal,
  isAllowanceOutSTaxFree,
  t,
  countries,
}) => {
  const { key, label, data } = editData?.item;
  const language = localStorage.getItem("i18nextLng");
  const fileName = (isFileUploaded && data?.uploadFile?.[0]?.name) || data?.fileName;
  const [fileSize, setFileSize] = useState(null);

  return (
    <>
      <div className="form-row mb-3">
        <div className="form-group col-xxl-4 col-xl-4 col-lg-12 col-md-12 col-sm-12 col-12">
          <label htmlFor="isAllowanceOutSTaxFree " className="text-muted small">
            {t("Is the {{label}} free of tax?", {
              label
            })}
          </label>

          <div className="d-flex align-items-center">
            <div className="form-check form-check-inline">
              <input
                className={`form-check-input change_radio_bg ${errors.isAllowanceOutSTaxFree ? "is-invalid" : ""
                  }`}
                type="radio"
                {...register("isAllowanceOutSTaxFree", {
                  required: true,
                })}
                value="1"
              />
              <label
                className="form-check-label text-muted"
                htmlFor="taxFreeYes"
              >
                {t("Yes")}
              </label>
            </div>
            <div className="form-check form-check-inline">
              <input
                className={`form-check-input change_radio_bg ${errors.isAllowanceOutSTaxFree ? "is-invalid" : ""
                  }`}
                type="radio"
                {...register("isAllowanceOutSTaxFree", {
                  required: true,
                })}
                value="0"
              />
              <label
                className="form-check-label text-muted"
                htmlFor="taxFreeNo"
              >
                {t("No")}
              </label>
            </div>
          </div>
        </div>

        <div className="form-group col-xxl-4 col-xl-4 col-lg-12 col-md-12 col-sm-12 col-12">
          <label htmlFor="uploadFile" className="text-muted small">
            {`${t("Upload File")} (${t("PDF files up to 1 MB only")})`}
          </label>

          {/* if file is uploaded */}
          {fileName ? (
            <div className="mb-2 d-flex align-items-center flex-wrap">
              <span className="text-success">
                {fileName}
              </span>
              <MdDelete
                className="ml-2 cursor-pointer"
                onClick={() => {
                  setValue("uploadFile", null);
                  setValue("fileName", null);
                  setOpenModal((prev) => ({
                    ...prev,
                    item: {
                      ...prev.item,
                      data: {
                        ...prev.item.data,
                        uploadFile: null,
                        fileName: null,
                      },
                    },
                  }));
                }}
              />
            </div>
          ) : (
            // if file is not uploaded
            <input
              type="file"
              accept=".pdf"
              className={`form-control-file p-2 rounded border ${errors.uploadFile ? "border-danger" : ""
                }`}

              {...register("uploadFile", {
                required:
                  (key === NEW_ARTICLES.TRAVEL || key === NEW_ARTICLES.MATERIAL_VAT) &&
                    !isFileUploaded
                    ? true
                    : "",
                validate: (value) => {
                  if (value && value[0]) {
                    const file = value[0];
                    const isPDF = file?.type === "application/pdf";
                    const sizeInMB = file.size / (1024 * 1024);
                    setFileSize(sizeInMB?.toFixed(2));
                    if (!isPDF) {
                      const errorMessage = t("Please upload a valid PDF file.");
                      toast.error(errorMessage);
                      return "Invalid file type.";
                    }
                    if (sizeInMB > 1) {
                      toast.error(t("Please select a file up to 1 MB in size."));
                      return "Invalid file size.";
                    }
                    setValue("fileName", value[0].name);
                  }
                  return true;
                },
              })}
            />
          )}
        </div>

        {(!isFileUploaded && isAllowanceOutSTaxFree) ? (
          <div className="form-group col-xxl-4 col-xl-4 col-lg-12 col-md-12 col-sm-12 col-12">
            <label htmlFor="isTaxFreeArticle" className="text-muted small">
              {t("Do you want to show the {{label}} on the invoice?", {
                label
              })}
            </label>

            <div className="d-flex align-items-center">
              <div className="form-check form-check-inline">
                <input
                  className={`form-check-input change_radio_bg ${errors.isArticleShowInInvoiceOS ? "is-invalid" : ""
                    }`}
                  type="radio"
                  {...register("isArticleShowInInvoiceOS", {
                    required: true,
                  })}
                  value="1"
                />
                <label
                  className="form-check-label text-muted"
                  htmlFor="showYes"
                >
                  {t("Yes")}
                </label>
              </div>
              <div className="form-check form-check-inline">
                <input
                  className={`form-check-input change_radio_bg ${errors.isArticleShowInInvoiceOS ? "is-invalid" : ""
                    }`}
                  type="radio"
                  {...register("isArticleShowInInvoiceOS", {
                    required: true,
                  })}
                  value="0"
                />
                <label className="form-check-label text-muted" htmlFor="showNo">
                  {t("No")}
                </label>
              </div>
            </div>
          </div>
        ) : (
          ""
        )}

        {isFileUploaded ? (
          <div className="form-group col-xxl-4 col-xl-4 col-lg-12 col-md-12 col-sm-12 col-12">
            <label htmlFor="showPdfToCustomer" className="text-muted small">
              {t("Do you want to show the PDF to the customer?")}
            </label>

            <div className="d-flex align-items-center">
              <div className="form-check form-check-inline">
                <input
                  className={`form-check-input change_radio_bg ${errors.isAosPdfShowToCustomer ? "is-invalid" : ""
                    }`}
                  type="radio"
                  {...register("isAosPdfShowToCustomer", {
                    required: isFileUploaded && true,
                  })}
                  value="1"
                />
                <label
                  className={`form-check-label ${!errors.isAosPdfShowToCustomer && "text-muted"
                    } `}
                  htmlFor="pdfShowYes"
                >
                  {t("Yes")}
                </label>
              </div>
              <div className="form-check form-check-inline">
                <input
                  className={`form-check-input change_radio_bg ${errors.isAosPdfShowToCustomer ? "is-invalid" : ""
                    }`}
                  type="radio"
                  {...register("isAosPdfShowToCustomer", {
                    required: isFileUploaded && true,
                  })}
                  value="0"
                />
                <label
                  className={`form-check-label ${!errors.isAosPdfShowToCustomer && "text-muted"
                    }`}
                  htmlFor="pdfShowNo"
                >
                  {t("No")}
                </label>
              </div>
            </div>
          </div>
        ) : (
          ""
        )}
      </div>

      <div className="form-row mb-3">
        {(isFileUploaded && isAllowanceOutSTaxFree) ? (
          <div className="form-group col-xxl-4 col-xl-4 col-lg-12 col-md-12 col-sm-12 col-12">
            <label htmlFor="isTaxFreeArticle" className="text-muted small">
              {t("Do you want to show the {{label}} on the invoice?", {
                label
              })}
            </label>

            <div className="d-flex align-items-center">
              <div className="form-check form-check-inline">
                <input
                  className={`form-check-input change_radio_bg ${errors.isArticleShowInInvoiceOS ? "is-invalid" : ""
                    }`}
                  type="radio"
                  {...register("isArticleShowInInvoiceOS", {
                    required: true,
                  })}
                  value="1"
                />
                <label
                  className="form-check-label text-muted"
                  htmlFor="showYes"
                >
                  {t("Yes")}
                </label>
              </div>
              <div className="form-check form-check-inline">
                <input
                  className={`form-check-input change_radio_bg ${errors.isArticleShowInInvoiceOS ? "is-invalid" : ""
                    }`}
                  type="radio"
                  {...register("isArticleShowInInvoiceOS", {
                    required: true,
                  })}
                  value="0"
                />
                <label className="form-check-label text-muted" htmlFor="showNo">
                  {t("No")}
                </label>
              </div>
            </div>
          </div>
        ) : (
          ""
        )}

        <div className="form-group col-xxl-4 col-xl-4 col-lg-12 col-md-12 col-sm-12 col-12">
          <label htmlFor="tripStartedDateOs" className="text-muted small">
            {t("Trip Started Date")}
          </label>
          <input
            type="date"
            className={`form-control shadow-sm rounded ${errors.tripStartedDateOs ? "is-invalid" : ""
              }`}
            {...register("tripStartedDateOs", {
              required: true,
            })}
            id="tripStartedDateOs"
          />
        </div>

        <div className="form-group col-xxl-4 col-xl-4 col-lg-12 col-md-12 col-sm-12 col-12">
          <label htmlFor="tripEndedDateOs" className="text-muted small">
            {t("Trip Ended Date")}
          </label>
          <input
            type="date"
            className={`form-control shadow-sm rounded ${errors.tripEndedDateOs ? "is-invalid" : ""
              }`}
            {...register("tripEndedDateOs", {
              required: true,
            })}
            id="tripEndedDateOs"
          />
        </div>
        {!isFileUploaded ? (
          <div className="form-group col-xxl-4 col-xl-4 col-lg-12 col-md-12 col-sm-12 col-12">
            <label htmlFor="reasonForTrip" className="text-muted small">
              {t("Reason For Trip")}
            </label>
            <input
              type="text"
              className={`form-control shadow-sm rounded ${errors.reasonForTrip ? "is-invalid" : ""
                }`}
              {...register("reasonForTrip", {
                required: isAllowanceOutSTaxFree && true,
              })}
              id="reasonForTrip"
              placeholder={t("Enter reason")}
            />
          </div>
        ) : (
          ""
        )}
      </div>

      <div className="form-row mb-3">
        {isFileUploaded ? (
          <div className="form-group col-xxl-4 col-xl-4 col-lg-12 col-md-12 col-sm-12 col-12">
            <label htmlFor="reasonForTrip" className="text-muted small">
              {t("Reason For Trip")}
            </label>
            <input
              type="text"
              className={`form-control shadow-sm rounded ${errors.reasonForTrip ? "is-invalid" : ""
                }`}
              {...register("reasonForTrip", {
                required: isAllowanceOutSTaxFree && true,
              })}
              id="reasonForTrip"
              placeholder={t("Enter reason")}
            />
          </div>
        ) : (
          ""
        )}

        <div className="form-group col-xxl-4 col-xl-4 col-lg-12 col-md-12 col-sm-12 col-12">
          <label htmlFor="country" className="text-muted small">
            {t("Country")}
          </label>
          <select
            className="form-control shadow-sm rounded"
            id="country"
            {...register("country", {
              required: true,
            })}
          >
            <option value="" disabled>
              {t("Select Country")}
            </option>
            {countries?.map((country, index) => (
              <option key={index} value={country.landellerOmråde}>
                {country.landellerOmråde}
              </option>
            ))}
          </select>
        </div>

        <div className="form-group col-xxl-4 col-xl-4 col-lg-12 col-md-12 col-sm-12 col-12">
          <label htmlFor="destination" className="text-muted small">
            {t("Destination")}
          </label>
          <input
            type="text"
            className={`form-control shadow-sm rounded ${errors.destination ? "is-invalid" : ""
              }`}
            {...register("destination", {
              required: isAllowanceOutSTaxFree && true,
            })}
            id="destination"
            placeholder={t("Enter destination")}
          />
        </div>

      <FoodExpense
      value={data?.foodAllowance || data?.dailyFoodRate}
        t={t}
        isAllowanceOutSTaxFree={isAllowanceOutSTaxFree}
        register={register}
        setValue={setValue}
      />

      </div >
    </>
  );
};

export default AllowanceOutsideSweden;
